const defaultSourceString = 'N/A';

/**
 * Given a string, generate an HSL code
 * https://medium.com/@pppped/compute-an-arbitrary-color-for-user-avatar-starting-from-his-username-with-javascript-cd0675943b66
 * @param  {string} sourceString
 * @param  {number|string} saturation
 * @param  {number|string} lightness
 * @return {string}
 */
export const stringToHsl = (
  sourceString: string = defaultSourceString,
  saturation: number | string = 50,
  lightness: number | string = 70,
): string => {
  let hash = 0;
  let i;

  for (i = 0; i < sourceString.length; i += 1) {
    hash = sourceString.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = hash % 360;

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};
